import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../components/LanguageSelector';

const TEXT_DARK = '#1A1A2E';
const TEXT_SECONDARY = '#6B7280';

const LanguagePage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const fromPath = (location.state as { from?: string } | null)?.from;

  return (
    <div
      style={{
        minHeight: '100%',
        padding: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        direction: i18n.language?.startsWith('he') ? 'rtl' : 'ltr',
      }}
    >
      <div>
        <h1
          style={{
            fontSize: 24,
            fontWeight: 700,
            color: TEXT_DARK,
            margin: '0 0 8px 0',
          }}
        >
          {t('language_page_title', 'Choose Language')}
        </h1>
        <p
          style={{
            fontSize: 15,
            color: TEXT_SECONDARY,
            margin: 0,
            lineHeight: 1.5,
          }}
        >
          {t('language_page_subtitle', 'Select your preferred language for the app.')}
        </p>
      </div>

      <LanguageSelector fromPath={fromPath} />
    </div>
  );
};

export default LanguagePage;
